import DealResult from './DealResult'
export default DealResult
